export var CodeStyles = {
    editorWrapper: {
        display: 'flex',
        backgroundColor: '#272822',
        borderRadius: '5px',
        overflow: 'auto',
        minHeight: '180px'
    },
    editorWrapperModal: {
        display: 'flex',
        backgroundColor: '#272822',
        borderRadius: '5px',
        overflow: 'hidden',
        minHeight: '180px',
        border: '1px solid #444',
    },
    editorBoxModal: {
        fontFamily: '"Fira code", "Fira Mono", monospace',
        color: '#f8f8f2',
        whiteSpace: 'pre',
        width: '100%',
        padding: '0',
        overflowY: 'auto',
    },
    editorBox: {
        fontFamily: '"Fira code", "Fira Mono", monospace',
        color: '#f8f8f2',
        whiteSpace: 'pre',
        width: '100%',
    },
    lineNumbers: {
        counterReset: 'line',
        textAlign: 'right',
        paddingRight: '10px',
        paddingLeft: '10px',
        userSelect: 'none',
        color: '#75715e',
        fontSize: '14px',
        paddingTop: '10px',
        paddingBottom: '10px',
        overflowY: 'hidden',
        height: '100%'
    }
};
//# sourceMappingURL=CodeStyles.js.mapexport var CodeStyles = {
    editorWrapper: {
        display: 'flex',
        backgroundColor: '#272822',
        borderRadius: '5px',
        overflow: 'auto',
        minHeight: '180px'
    },
    editorWrapperModal: {
        display: 'flex',
        backgroundColor: '#272822',
        borderRadius: '5px',
        overflow: 'hidden',
        minHeight: '180px',
        border: '1px solid #444',
    },
    editorBoxModal: {
        fontFamily: '"Fira code", "Fira Mono", monospace',
        color: '#f8f8f2',
        whiteSpace: 'pre',
        width: '100%',
        padding: '0',
        overflowY: 'auto',
    },
    editorBox: {
        fontFamily: '"Fira code", "Fira Mono", monospace',
        color: '#f8f8f2',
        whiteSpace: 'pre',
        width: '100%',
    },
    lineNumbers: {
        counterReset: 'line',
        textAlign: 'right',
        paddingRight: '10px',
        paddingLeft: '10px',
        userSelect: 'none',
        color: '#75715e',
        fontSize: '14px',
        paddingTop: '10px',
        paddingBottom: '10px',
        overflowY: 'hidden',
        height: '100%'
    }
};
//# sourceMappingURL=CodeStyles.js.map